import { useEffect, useState } from "react";
import { default as axios } from "../axiosConfig";
import MetricGroupCard from "./MetricGroupCard";
import Skeleton from "@mui/material/Skeleton";
import { useNavigate } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { API_GetManagerUserSummary } from "../Assets/ApiUrlContainer";

function MetricCardSkeleton() {
  return (
    <div className="metric-card">
      <Skeleton variant="text" width={120} height={30} />
      <Skeleton variant="text" width={60} height={40} />
    </div>
  );
}

export default function ManagerLandingPage({ user }) {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axios.get(`${API_GetManagerUserSummary}?email=${user.Email}`);
        setSummary(res.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching Manager landing summary:", err);
        setError("Failed to load dashboard data.");
      }
    };

    if (user?.Email) {
      fetchSummary();
    }
  }, [user?.Email]);

  const isLoading = !summary && !error;

  return (
    <div className="landing-content">
      <div className="metric-panel">
        <div className="welcome-header">
          <h1>Welcome {user.FirstName} {user.LastName}</h1>
        </div>

        {error && <div className="error-message">{error}</div>}

        {isLoading ? (
          <div className="metric-group">
            <div className="landing-grid">
              {[...Array(8)].map((_, i) => (
                <MetricCardSkeleton key={i} />
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="grid-two-columns">
              {/* Left Column */}
              <div className="multGroupedCards">
                <MetricGroupCard
                  className="group-card group-user"
                  title={<><GroupIcon style={{ marginRight: "8px" }} />User Summary</>}
                  metrics={[
                    {
                      label: "Active Consultants",
                      value: summary.totals.activeConsultants ?? 0
                    }
                  ]}
                />

                <MetricGroupCard
                  className="group-card group-contracts"
                  title={<><CalendarMonthIcon style={{ marginRight: "8px" }} />Contracts</>}
                  metrics={[
                    {
                      label: "Contracts Expiring Soon",
                      value: summary.contracts.expiringSoon ?? 0
                    }
                  ]}
                />
              </div>

              {/* Right Column */}
              <div>
                <MetricGroupCard
                  className="group-card group-jobs"
                  title={<><WorkOutlineIcon style={{ marginRight: "8px" }} />Job Activity</>}
                  metrics={[
                    {
                      label: "New Jobs This Week",
                      value: summary.jobs.newJobsThisWeek ?? 0,
                      onClick: () => navigate("/jobs")
                    },
                    {
                      label: "Applications This Week",
                      value: summary.jobs.applicationsThisWeek ?? 0
                    }
                  ]}
                />
              </div>
            </div>

            {/* Approvals */}
            <MetricGroupCard
              className="group-card group-approvals"
              title={<><AssignmentTurnedInIcon style={{ marginRight: "8px" }} />Pending Approvals</>}
              metrics={[
                {
                  label: "Leave Requests",
                  value: summary.approvals.leaveRequests ?? 0,
                  onClick: () => navigate("/tasks/leaverequests")
                },
                {
                  label: "Timesheets to Approve",
                  value: summary.approvals.timesheetsToApprove ?? 0,
                  onClick: () => navigate("/tasks/timesheets")
                }
              ]}
            />
          </>
        )}
      </div>
    </div>
  );
}